import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const Ebay = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <g clipPath="url(#clip0_4_111)">
        <path
          d="M2.5911 7.74917C1.18138 7.74917 0.00666646 8.34563 0.00666646 10.1451C0.00666646 11.5707 0.796577 12.4685 2.6275 12.4685C4.78258 12.4685 4.92072 11.0527 4.92072 11.0527H3.87649C3.87649 11.0527 3.65259 11.815 2.5638 11.815C1.677 11.815 1.03918 11.2176 1.03918 10.3802H5.02993V9.85471C5.02993 9.02625 4.50259 7.74917 2.5911 7.74917ZM2.5547 8.42076C3.39883 8.42076 3.97431 8.9365 3.97431 9.7095H1.06228C1.06228 8.88887 1.81343 8.42076 2.5547 8.42076Z"
          fill="#E53238"
        />
        <path
          d="M5.02918 6.00665V11.5648C5.02918 11.8803 5.00661 12.3233 5.00661 12.3233H6.00259C6.00259 12.3233 6.03834 12.0051 6.03834 11.7143C6.03834 11.7143 6.53042 12.4821 7.86842 12.4821C9.27739 12.4821 10.2344 11.5065 10.2344 10.1088C10.2344 8.80856 9.35536 7.76278 7.87069 7.76278C6.48041 7.76278 6.0484 8.51152 6.0484 8.51152V6.00665H5.02918ZM7.61361 8.45026C8.57041 8.45026 9.17883 9.15846 9.17883 10.1088C9.17883 11.1279 8.47613 11.7946 7.62044 11.7946C6.59925 11.7946 6.0484 10.9994 6.0484 10.1179C6.0484 9.29649 6.54269 8.45026 7.61361 8.45026Z"
          fill="#0064D2"
        />
        <path
          d="M12.7097 7.74917C10.5889 7.74917 10.4528 8.90729 10.4528 9.09236H11.5085C11.5085 9.09236 11.5638 8.41622 12.6369 8.41622C13.3342 8.41622 13.8745 8.73452 13.8745 9.34647V9.56429H12.6369C10.9939 9.56429 10.1252 10.0436 10.1252 11.0164C10.1252 11.9737 10.9278 12.4946 12.0124 12.4946C13.4905 12.4946 13.9666 11.68 13.9666 11.68C13.9666 12.004 13.9917 12.3233 13.9917 12.3233H14.9301C14.9301 12.3233 14.8937 11.9275 14.8937 11.6744V9.48601C14.8937 8.05114 13.7332 7.74917 12.7097 7.74917ZM13.8745 10.2177V10.5081C13.8745 10.8869 13.6401 11.8286 12.2604 11.8286C11.5048 11.8286 11.1809 11.4526 11.1809 11.0164C11.1809 10.2228 12.2718 10.2177 13.8745 10.2177Z"
          fill="#F5AF02"
        />
        <path
          d="M14.3253 7.93086H15.5128L17.2172 11.3362L18.9176 7.93086H19.9933L16.896 13.9934H15.7676L16.6614 12.3034L14.3253 7.93086Z"
          fill="#86B817"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_111">
          <rect width="20" height="8" fill="white" transform="translate(0 6)" />
        </clipPath>
      </defs>
    </svg>
  )
})

export default Ebay
